export const WeChatIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="currentColor"
      className="h-6 w-6 opacity-80 transition-opacity duration-200 hover:opacity-100 lg:h-8 lg:w-8"
    >
      <path d="M14.58 14.41a11.31 11.31 0 0 1 7.65-3.09 8.8 8.8 0 0 0-1.85-4.69 11.84 11.84 0 0 0-12.94-3.8C4 4 1.41 6.14.37 9.73c-1.13 3.88.38 7.65 3.94 10.17a1 1 0 0 1 .46 1.33c-.25.82-.39 1.67-.6 2.64 1.17-.73 2.16-1.39 3.19-2a2.11 2.11 0 0 1 1.12-.19c1.06.09 2.12.25 3.28.39a9.08 9.08 0 0 1 2.82-7.66zm1.11-5.67a1.33 1.33 0 1 1 0 2.66 1.36 1.36 0 0 1-1.38-1.31 1.38 1.38 0 0 1 1.38-1.35zm-8.53 2.65a1.33 1.33 0 1 1 .08-2.65 1.37 1.37 0 0 1 1.32 1.37 1.35 1.35 0 0 1-1.4 1.28z"></path>
      <path d="M30.26 16c-3-3.83-9.15-4.75-13.36-2-4.75 3.11-5.33 8.92-1.23 12.71a9.45 9.45 0 0 0 7.68 2.5c1-.09 1.92-.62 2.83-.53a10.23 10.23 0 0 1 2.73 1.15 3.4 3.4 0 0 0-.19-.7c-.59-1.07-.26-1.74.66-2.55A7.6 7.6 0 0 0 30.26 16zM18.2 19.47a1.11 1.11 0 1 1 1.11-1.06 1.11 1.11 0 0 1-1.11 1.06zm6.89 0A1.09 1.09 0 0 1 24 18.32a1.11 1.11 0 0 1 1.1-1.06 1.09 1.09 0 0 1 1.08 1.15 1.07 1.07 0 0 1-1.09 1.05z"></path>
    </svg>
  );
};
